import { createSlice } from "@reduxjs/toolkit";

// Define initial state separately so we can reuse it
const initialState = {
  currentPage: 0,
  details: {
    doctorName: null,
    doctorId: null,
    userName: null,
    userMobile: null,
    userAge: null,
    userTitle: null,
    userEmail: null,
    userGender: null,
    cp_id: null,
    slotTiming: null,
    amount: null,
    degree: null,
    specialization: null,
    experience: null,
  },
  isReschedule: false,
  appointmentId: null,
  previousAppointment: null,
};

const AppointmentSlice = createSlice({
  name: "Appointment",
  initialState,
  reducers: {
    selectDoctor(state, action) {
      state.details.doctorName = action.payload?.name;
      state.details.doctorId = action.payload?.id;
      state.details.amount = action.payload?.amount;
      state.details.degree = action.payload?.degree;
      state.details.specialization = action.payload?.specialization;
      state.details.experience = action.payload?.experience;
      state.currentPage = 1;
    },
    selectSlot(state, action) {
      state.details.slotTiming = action.payload;
      state.currentPage = 2;
    },
    addpatientDetails(state, action) {
      state.details.userAge = action.payload.userAge;
      state.details.userName = action.payload.title + " " + action.payload.name;
      state.details.userMobile = action.payload.mobile;
      state.currentPage = 3;
    },
    back(state) {
      state.currentPage = state.currentPage - 1;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    startReschedule(state, action) {
      state.isReschedule = true;
      state.currentPage = 1;
      state.details.doctorName = action.payload?.doctorName;
      state.details.doctorId = action.payload?.doctorId;
      state.appointmentId = action.payload?.appointmentId;
      state.details.userAge = action.payload?.userAge;
      state.details.userName = action.payload?.userName;
      state.details.userTitle = action.payload?.userTitle;
      state.details.userMobile = action.payload?.userMobile;
      state.details.userGender = action.payload?.userGender;
      state.details.userEmail = action.payload?.userEmail;
      state.details.cp_id = action.payload?.cp_id;
      state.details.service_ids = action.payload?.service_ids;
      state.details.procedure_ids = action.payload?.procedure_ids;
      state.previousAppointment = {
        date: action.payload?.appointmentDate,
        time: action.payload?.appointmentTime,
        endTime: action.payload?.slotEndTime,
        doctorName: action.payload?.doctorName,
      };
    },
    resetReschedule(state) {
      state.isReschedule = false;
      state.appointmentId = null;
      state.previousAppointment = null;
    },
    resetAppointmentState: () => initialState,
  },
});

export default AppointmentSlice.reducer;

export const {
  selectDoctor,
  selectSlot,
  addpatientDetails,
  back,
  setCurrentPage,
  startReschedule,
  resetReschedule,
  resetAppointmentState,
} = AppointmentSlice.actions;